const colors = {
  black: "#18191b",
  black30: "#000000",
  black10: "#161616",
  black20: "#1c1c1c",
  grey10: "#5d5d5c",
  grey20: "#f1f1f1",
  grey40: "#61636B",
  grey50: "#DCDCDC",
  gold10: "#B08F27",
  gold20: "#C9AF45",
  white100: "#ffffff",
  white10: "#F8FAFA",
  white20: "#F7F9F9",
  white30: "#F6F6F1",
  white40: "#eee2da",
  green10: "#9bad78",
  orange10: "#f5a08c",
};

const breakpoints = ["400", "800px", "1300px"];

export const theme = {
  breakpoints,
  colors,
};
